import * as React from 'react';
import { inject } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

// Polyfill ie11
// import 'core-js/es/array';

import { ROUTE_RATING } from '../../RouteList';
import {
  ROUTE_WELCOME,
  ROUTE_FORM,
  ROUTE_INTRO,
  ROUTE_READY
} from './RouteList';
import Form from './components/Form';
import Intro from './components/Intro';
import Welcome from './components/Welcome';
import Ready from './components/Ready';
import SubPageController from '../components/SubPageController';
import SubPageNavigator from '../components/SubPageNavigator';
import Image, { ImageType } from '../../components/image/image';

import '../../components/bubble/bubble.scss';
import Container from '../../components/layout/container';
import Bubble, { BubbleType } from '../../components/bubble/bubble';

@inject('routing', 'dataStore')
class Start extends React.Component<RouteComponentProps<any> & any> {
  public state = {
    index: 0,
    total: 0
  };

  private subViewRoutes = [
    {
      path: ROUTE_WELCOME,
      Component: Welcome
    },
    {
      Component: Form,
      path: ROUTE_FORM,
      validator: () => this.props.dataStore.nameValidator(),
      private: true,
      excludeFromSingaporePrivate: true
    },
    {
      path: ROUTE_INTRO,
      Component: Intro
    },
    {
      path: ROUTE_READY,
      Component: Ready
    }
  ];

  private onComplete = () => {
    const {
      routing: { push }
    } = this.props;
    push(ROUTE_RATING);
  };

  public render() {
    const {
      match,
      dataStore: { isPrivate, isSingaporePrivate }
    } = this.props;

    return (
      <Container>
        <Bubble type={BubbleType.Right}>
          <SubPageController
            subViewRoutes={this.subViewRoutes.filter(route =>
              isSingaporePrivate
                ? route.private !== isSingaporePrivate
                : route.private !== isPrivate
            )}
            match={match}
            onComplete={this.onComplete}
            render={renderProps => <SubPageNavigator {...renderProps} />}
          />
        </Bubble>
        <Image
          type={ImageType.startKleermaker}
          imgSrc="/images/svg/start-kleermaker.svg"
          alt={'Sporti'}
        />
        <Image
          type={ImageType.startRocket}
          imgSrc="/images/svg/start-flag-rocket.svg"
          alt={'Rocket'}
        />
      </Container>
    );
  }
}

export default withRouter(Start);



// WEBPACK FOOTER //
// ./src/containers/start/Start.tsx